import { render } from "./viewsTemplateMtlNo.vue?vue&type=template&id=5dc5726c"
import script from "./viewsTemplateMtlNo.vue?vue&type=script&lang=js"
export * from "./viewsTemplateMtlNo.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./viewsTemplateMtlNo.vue?vue&type=style&index=1&id=5dc5726c&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__